import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import MenuHorizontal from "../../layouts/MenuHorizontal";
import FormContato from '../../forms/FormContato';

const FaleConosco = props => (
  <div>
    <MenuHorizontal {...props} backFunction={props.history.goBack} />
    <div className="va-contato">
      <div className="va-contato-grade">
        <aside className="va-contato-info">
          <span className="va-contato-etiqueta"><Icon name="life ring outline" /> Suporte</span>
          <h1>Como podemos ajudar?</h1>
          <p>
            Conte para a nossa equipe sua dúvida, problema ou sugestão. Respondemos por e-mail,
            normalmente em até <b>1 dia útil</b>.
          </p>

          <ul className="va-contato-canais">
            <li>
              <span className="va-contato-icone"><Icon name="mail outline" /></span>
              <div>
                <b>E-mail</b>
                <a href="mailto:contato@voteassembleia.com.br">contato@voteassembleia.com.br</a>
              </div>
            </li>
            <li>
              <span className="va-contato-icone"><Icon name="question circle outline" /></span>
              <div>
                <b>Central de ajuda</b>
                <Link to="/ajuda">Veja as perguntas mais frequentes</Link>
              </div>
            </li>
            <li>
              <span className="va-contato-icone"><Icon name="clock outline" /></span>
              <div>
                <b>Atendimento</b>
                <span>Segunda a sexta, em horário comercial</span>
              </div>
            </li>
          </ul>

          <div className="va-contato-dica">
            <Icon name="lightbulb outline" />
            Para agilizar, informe o nome do condomínio e, se for o caso, o título da votação.
          </div>
        </aside>

        <FormContato />
      </div>
    </div>
  </div>
);

export default FaleConosco;
